// passwordUtils.ts
import zxcvbn from 'zxcvbn';

export const generateRandomPassword = (length: number = 16): string => {
  const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+~`|}{[]:;?><,./-=";
  let password = "";
  let hasNumber = false;

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * charset.length);
    const char = charset[randomIndex];
    if (/\d/.test(char)) {
      hasNumber = true;
    }
    password += char;
  }

  // Ensure the password has at least one number
  if (!hasNumber) {
    const randomIndex = Math.floor(Math.random() * length);
    password = password.substring(0, randomIndex) + Math.floor(Math.random() * 10) + password.substring(randomIndex + 1);
  }

  return password;
};

export const generateStrongPassword = (setPassword: (password: string) => void, setPasswordStrength: (strength: number) => void, setPasswordFeedback: (feedback: string) => void) => {
  const newPassword = generateRandomPassword();
  setPassword(newPassword);
  const result = zxcvbn(newPassword);
  setPasswordStrength(result.score);
  setPasswordFeedback(result.feedback.suggestions.join(" "));
};

export const togglePasswordVisibility = (showPassword: boolean, setShowPassword: (show: boolean) => void) => {
  setShowPassword(!showPassword);
};

export const copyPasswordToClipboard = (password: string) => {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(password)
      .then(() => {
        alert("Password copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy password: ", err);
        fallbackCopyTextToClipboard(password);
      });
  } else {
    fallbackCopyTextToClipboard(password);
  }
};

const fallbackCopyTextToClipboard = (text: string) => {
  const textArea = document.createElement("textarea");
  textArea.value = text;
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  try {
    const successful = document.execCommand("copy");
    const msg = successful ? "Password copied to clipboard!" : "Failed to copy password. Please try again.";
    alert(msg);
  } catch (err) {
    console.error("Fallback: Oops, unable to copy", err);
    alert("Failed to copy password. Please try again.");
  }
  document.body.removeChild(textArea);
};